import React from 'react';
import { MetricCard } from 'common/components';
import { formatCompactDuration, getDashboardMetricTheme } from 'components/InfoCards/dashboardMetricCard.utils';

type AITimeData = {
    totalCount: number;
    ai: number;
};

export type TotalAITimeProps = {
    callData: AITimeData;
};

const TotalAITime = ({ callData }: TotalAITimeProps) => (
    <MetricCard
        id='total-ai-time'
        label='Total AI Time'
        tooltip='Total duration handled by the AI agent in the selected range.'
        theme={getDashboardMetricTheme('Total AI Time')}
        primaryValue={formatCompactDuration(callData.totalCount ? callData.ai : 0)}
        showPercent={false}
    />
);

export default TotalAITime;
